module.exports = __webpack_public_path__ + "img/Trophy Cup Table35.533d8655.jpg";